/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from "swiper";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
Swiper.use([Autoplay, Pagination, Navigation]);
export function slider() {
    const logoSliderSelector = ".logo-slider__inner.swiper";
    const latestArticlesSliderSelector = ".articles-list__items-mobile.swiper";
    const productImageSliderSelector = ".product-page__media.swiper";

    //Fix the tabindex for accebility if the content of the slide is wrapped in an anchor tag
    const handleSlideChangeTransitionEnd = function (swiper) {
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
    const handleSlideChange = function () {
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {
        // Logo Slider
        const logoSlider = [];
        const logoSliderElements = document.querySelectorAll(logoSliderSelector);
        if (logoSliderElements) {
            logoSliderElements.forEach(slider => {

                logoSlider.push(new Swiper(slider, {
                    speed: 3000,
                    loop: true,
                    freeMode: true,
                    allowTouchMove: false,
                    slidesPerView: 'auto',
                    spaceBetween: 60,
                    autoplay: {
                        delay: 0.5,
                    },
                    breakpoints: {
                        // when window width is >= 768px
                        992: {
                            spaceBetween: 150,
                        },
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Articles Slider
        const articleSlider = [];
        const articleSliderElements = document.querySelectorAll(latestArticlesSliderSelector);
        if (articleSliderElements) {
            articleSliderElements.forEach(slider => {

                articleSlider.push(new Swiper(slider, {
                    slidesPerView: 1.3,
                    spaceBetween: 15,
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }

        // Product Images Slider
        const productImagesSlider = [];
        const productImagesSliderElements = document.querySelectorAll(productImageSliderSelector);
        if (productImagesSliderElements) {
            productImagesSliderElements.forEach(slider => {

                productImagesSlider.push(new Swiper(slider, {
                    slidesPerView: 1,
                    pagination: {
                        el: ".product-page__slider-pagination",
                        type: "bullets",
                        clickable: true,
                        enabled: true,
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .product-page__slider-next",
                        prevEl: '#' + slider.dataset.componentId + " .product-page__slider-prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }
    };

    init();
}
